import { render, staticRenderFns } from "./OnDemandDashboard.vue?vue&type=template&id=e0254bcc"
import script from "./OnDemandDashboard.vue?vue&type=script&lang=js"
export * from "./OnDemandDashboard.vue?vue&type=script&lang=js"
import style0 from "./OnDemandDashboard.vue?vue&type=style&index=0&id=e0254bcc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports